<template>
  <switcher
    :active="activeLocale"
    :inactive="inactiveLocale"
    @toggle="toggleLocale"
  />
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { LOCALES } from '@/locale'
import { SAVE_LOCALE } from '@/store/mutation-types'

import Switcher from '@/containers/Navigation/Switcher'

export default {
  components: {
    Switcher
  },
  data () {
    return {
      locales: LOCALES
    }
  },
  computed: {
    ...mapState({ activeLocale: state => state.i18n.locale }),
    inactiveLocale () {
      return this.locales.find(locale => locale !== this.activeLocale)
    }
  },
  methods: {
    ...mapMutations({ saveLocale: SAVE_LOCALE }),
    toggleLocale () {
      this.saveLocale(this.inactiveLocale)
      this.$router.replace({
        params: { ...this.$route.params, locale: this.activeLocale },
        query: this.$route.query
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Navigation/SwitcherContainer.vue